module.exports = {
  i18n: {
    locales: ['ja', 'en', 'zh-TW', 'zh-CN', 'ko'],
    defaultLocale: 'ja',
    localeDetection: false,
  },
}
